module.exports = __webpack_public_path__ + "static/media/instagram-stories-pool.2c50cae7.mp4";